import { Injectable } from '@angular/core';

/***** 所有專案固定參數 *****/
const storagekey_token = 'access_token';
const storagekey_isLoginRemberMe = 'remember_me';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  /*** Token ***/
  getToken() {
    return localStorage.getItem(storagekey_token);
  }
  setToken(value: any) {
    return localStorage.setItem(storagekey_token, value);
  }
  removeToken() {
    return localStorage.removeItem(storagekey_token);
  }

  /*** User ***/
  getUserRole() {
    return localStorage.getItem('userRole');
  }
  setUserRole(value: any) {
    return localStorage.setItem('userRole', value);
  }
  removeUserRole() {
    return localStorage.removeItem('userRole');
  }

}
